import React from "react";
import { shape, func, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CustomText from "pages/_components/CustomText/CustomText";
import CustomData from "pages/_components/CustomData/CustomData";
import { push } from "connected-react-router";
import { useDispatch } from "react-redux";
import EditReferenceForm from "pages/adheredServices/EditReference";
import { actions as adheredServicesActions } from "reducers/adheredServices";

const AdheredServicesItem = ({ receivedAdheredService, setDrawer, isDesktop }) => {
    const dispatch = useDispatch();
    const unbindHandeler = () => {
        dispatch(adheredServicesActions.setAdheredServicesData(receivedAdheredService));
        dispatch(push("/adheredServices/remove"));
    };
    const options = [
        {
            text: "adheredService.edit.reference",
            textType: "I18N",
            func: () =>
                setDrawer({
                    showDrawer: true,
                    contentDrawer: (
                        <EditReferenceForm
                            service={receivedAdheredService}
                            setDrawer={setDrawer}
                            isDesktop={isDesktop}
                        />
                    ),
                }),
        },
        {
            text: "adheredService.unbind.service",
            textType: "I18N",
            func: () => unbindHandeler(),
        },
    ];
    return (
        <>
            <GridTable.Data columnStart={1} columnWidth={1} rowStart={1}>
                {isDesktop ? (
                    <CustomText text={receivedAdheredService?.serviceName} />
                ) : (
                    <CustomData
                        titleText="adheredServices.business"
                        titleTextType="I18N"
                        valueText={receivedAdheredService?.serviceName}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 2 : 1} columnWidth={1} rowStart={isDesktop ? 1 : 2}>
                {isDesktop ? (
                    <CustomText text={receivedAdheredService?.alias} />
                ) : (
                    <CustomData
                        titleText="adheredServices.reference"
                        titleTextType="I18N"
                        valueText={receivedAdheredService?.alias}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 3 : 1} columnWidth={1} rowStart={isDesktop ? 1 : 3}>
                {isDesktop ? (
                    <CustomText text={receivedAdheredService?.serviceId} />
                ) : (
                    <CustomData
                        titleText="adheredServices.paymentCode"
                        titleTextType="I18N"
                        valueText={receivedAdheredService?.serviceId}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 4 : 2}
                columnWidth={1}
                rowStart={1}
                alignY="center"
                className="adhered-services-button">
                <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={options} />
            </GridTable.Data>
        </>
    );
};

AdheredServicesItem.propTypes = {
    receivedAdheredService: shape(echeqPropTypes).isRequired,
    setDrawer: func.isRequired,
    isDesktop: bool.isRequired,
};

export default AdheredServicesItem;
